module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-11 at 4.40.41 PM.8081202b.jpeg";